import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as SearchIcon } from "feather-icons/dist/icons/search.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import { VisuallyHidden } from "./ui";

/** Champ de recherche du blog (contrôlé par la page). */

const Form = tw.form`relative w-full`;
const Input = styled.input`
  ${tw`w-full pl-12 pr-12 py-4 rounded-lg bg-gray-100 border-2 border-gray-200 text-gray-900 font-medium text-base transition duration-300`}
  ${tw`hover:border-gray-300 focus:border-primary-500 focus:outline-none focus:bg-white`}
  &::placeholder {
    ${tw`text-gray-500 font-medium`}
  }
`;
const IconLeft = styled.span`
  ${tw`absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-500`}
  svg {
    ${tw`w-5 h-5`}
  }
`;
const ClearButton = styled.button`
  ${tw`absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hocus:text-primary-500 focus:outline-none transition duration-300`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

export default function SearchBox({ value = "", onChange, onSubmit, placeholder = "Rechercher un article, un sujet, un acteur local…", autoFocus = false }) {
  const handleSubmit = event => {
    event.preventDefault();
    if (onSubmit) onSubmit(value);
  };
  return (
    <Form role="search" onSubmit={handleSubmit}>
      <label htmlFor="blog-search">
        <VisuallyHidden>Rechercher dans le blog</VisuallyHidden>
      </label>
      <IconLeft>
        <SearchIcon aria-hidden="true" />
      </IconLeft>
      <Input
        id="blog-search"
        type="search"
        name="q"
        value={value}
        onChange={event => onChange && onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        autoFocus={autoFocus}
      />
      {value && (
        <ClearButton type="button" onClick={() => onChange && onChange("")} aria-label="Effacer la recherche">
          <CloseIcon aria-hidden="true" />
        </ClearButton>
      )}
    </Form>
  );
}
